import api from '../api'

export const fetchContentItemsByPage = async (id: string, pageId: string) => {
  const res = await api.get(`/content/${id}/pages/${pageId}/items/`)
  return res.data
}

// Delete a content item from a specific page
export const deleteContentItemFromPage = async (id: string, pageIndex: number, itemId: string) => {
  const res = await api.delete(`/content/${id}/pages/${pageIndex}/${itemId}/`)
  return res.data
}

// Fetch all pages for a content item
export const fetchPages = async (id: string) => {
  const res = await api.get(`/content/${id}/pages/`)
  return res.data
}

// Create a new page for a content item
export const createPage = async (id: string, pageData: any) => {
  const res = await api.post(`/content/${id}/pages/`, pageData)
  return res.data
}

// Update a page for a content item
export const updatePage = async (id: string, pageId: string, pageData: any) => {
  const res = await api.patch(`/content/${id}/pages/${pageId}/`, pageData)
  return res.data
}

// Delete a page for a content item
export const deletePage = async (id: string, pageId: string) => {
  const res = await api.delete(`/content/${id}/pages/${pageId}/`)
  return res.data
}